import { useState } from "react";
// redux
import { useSelector } from "react-redux";
// axios
import EnhancedAxios from "../../axios/EnhancedAxios";
import { AxiosResponse, AxiosError } from "axios";
// mui
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    Typography,
} from "@mui/material";
// form
import { useForm, SubmitHandler } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
// components
import InputField from "../form/InputField";
import SubmitButton from "../button/SubmitButton";
// schema
import { pushGiftNotificationSchema } from "../../schemes/notification/pushGiftNotificationSchema";
// types
import { ReduxUserReducerState } from "../../types/global";
import { errorAlert, successAlert } from "../../utils/alerts/alerts";

type Props = {
    open: boolean;
    onClose: () => void;
    giftId: string | number;
};

type FormValues = {
    message: string;
};

const PushGiftNotificationModal = ({ open, onClose, giftId }: Props) => {
    const userToken = useSelector(
        (state: ReduxUserReducerState) => state.user.userToken
    );
    const [submitting, setSubmitting] = useState(false);

    // --------------------------- form handle ---------------------------
    const form = useForm<FormValues>({
        resolver: yupResolver(pushGiftNotificationSchema),
        defaultValues: {
            message: "",
        },
        mode: "all",
    });

    const {
        register,
        reset,
        formState: { errors },
        handleSubmit,
    } = form;

    const onSubmit: SubmitHandler<FormValues> = (data) => {
        setSubmitting(true);
        EnhancedAxios("multipart/form-data", userToken)
            .post(`/admin/gifts/${giftId}/send-reminder`, data)
            .then((res: AxiosResponse) => {
                setSubmitting(false);
                successAlert("تم ارسال الاشعار بنجاح");
                reset();
                onClose();
            })
            .catch((error: AxiosError) => {
                setSubmitting(false);
                errorAlert(error);
            });
    };

    const handleClose = () => {
        reset();
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="md"
            fullWidth
            sx={{
                "& .MuiPaper-root": {
                    minWidth: { xs: "290px", sm: "500px" },
                },
            }}
        >
            <DialogTitle>
                <Typography variant="h6" component="div">
                    ارسال اشعار للمستخدمين في هذه الهدية
                </Typography>
            </DialogTitle>
            <DialogContent
                sx={{
                    minWidth: { xs: "290px", sm: "500px" },
                    width: "100%",
                }}
            >
                <Stack
                    gap="10px"
                    width="100%"
                    minWidth="290px"
                    component="form"
                    py={4}
                    onSubmit={handleSubmit(onSubmit)}
                >
                    <InputField
                        type="text"
                        label="نص الاشعار"
                        registration={{
                            ...register("message"),
                        }}
                        errorMessage={errors?.message?.message}
                        multiline={true}
                        minRows={3}
                        maxRows={8}
                    />
                    <SubmitButton label="ارسال" disabled={submitting} />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} disabled={submitting}>
                    الغاء
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default PushGiftNotificationModal;

